export const listingConfigDrawer = {
  close: `Close`,
  componentUnavailable: `Component not available.`,
};
